var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"buttons"},[_c('div',[_c('router-link',{staticClass:"button login button-200",attrs:{"to":"/console/login","tag":"button"}},[_vm._v("Login")])],1),_c('div',[_c('router-link',{staticClass:"button register button-200",attrs:{"to":"/console/register","tag":"button"}},[_vm._v("Register")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }